import React, { useEffect, useState } from 'react';
import DatePicker from 'react-multi-date-picker';
import "react-multi-date-picker/styles/layouts/mobile.css";

const Filter = ({ currentFilters = {}, filterItems = {}, onChange = () => { }, resetFilter, onClose = () => { } }) => {
    const [draft, setDraft] = useState(currentFilters);

    useEffect(() => {
        setDraft(currentFilters);
    }, [currentFilters]);

    const updateDraft = (key, value) => {
        const formattedValue = value?.toDate?.() || value;
        setDraft((prev) => ({ ...prev, [key]: formattedValue }));
    };

    const applyFilters = () => {
        Object.keys(draft).forEach((key) => {
            if (draft[key] !== currentFilters[key]) {
                onChange(key, draft[key]);
            }
        });
        onClose();
    };

    const hasChanges = JSON.stringify(draft) !== JSON.stringify(currentFilters);

    return (
        <div className="list-filter-panel">
            <div className="row g-3">
                {Array.isArray(filterItems?.sort) && (
                    <div className="col-12">
                        <label className="form-label small fw-bold text-muted text-uppercase">Sort by</label>
                        <div className="input-group">
                            <select className="form-select border-light-subtle" value={draft?.sortBy || ""} onChange={(e) => updateDraft('sortBy', e.target.value)} >
                                {filterItems.sort.map((item) => (<option key={item.key} value={item.key}>{item.name}</option>))}
                            </select>
                            <span className="input-group-text sort-arrow">
                                <i className={draft?.sort === true ? "i-active" : ""} onClick={() => updateDraft('sort', true)} aria-label="Sort ascending" role="button">▲</i>
                                <i className={draft?.sort === false ? "i-active" : ""} onClick={() => updateDraft('sort', false)} aria-label="Sort descending" role="button">▼</i>
                            </span>
                        </div>
                    </div>
                )}

                {filterItems?.dropdown?.map((group) => (
                    <div className="col-12" key={group?.key}>
                        <label className="form-label small fw-bold text-muted text-uppercase" htmlFor={`filter-${group?.key}`}>{group?.name}</label>
                        <select
                            id={`filter-${group?.key}`}
                            className="form-select border-light-subtle"
                            value={draft[group?.key]}
                            onChange={(e) => {
                                let val = e.target.value;
                                if (val === "true") val = true;
                                if (val === "false") val = false;
                                updateDraft(group?.key, val);
                            }}
                            disabled={group.disabled}
                        >
                            {group?.options.map(opt => (
                                <option key={String(opt?.key)} value={opt?.key}>{opt?.name}</option>
                            ))}
                        </select>
                    </div>
                ))}

                {filterItems?.datepicker?.map((picker) => (
                    <div className="col-12 d-flex flex-column" key={picker.key}>
                        <label className="form-label small fw-bold text-muted text-uppercase">{picker.name}</label>
                        <DatePicker
                            containerClassName="w-100"
                            inputClass="form-control border-light-subtle"
                            value={draft[picker.key]}
                            onChange={(date) => updateDraft(picker.key, date)}
                            minDate={picker.minStartDate}
                            maxDate={picker.minEndDate}
                            format="YYYY-MM-DD"
                        />
                    </div>
                ))}

                {filterItems?.daterangepicker?.map((range) => (
                    <div className="col-12" key={range.key}>
                        <label className="form-label small fw-bold text-muted text-uppercase">{range.name}</label>
                        <div className="row g-2">
                            <div className="col-6">
                                <DatePicker
                                    containerClassName="w-100"
                                    inputClass="form-control border-light-subtle"
                                    placeholder="From"
                                    value={draft[range.from.key]}
                                    onChange={(date) => updateDraft(range.from.key, new Date(new Date(date).setHours(0, 0, 0, 0)))}
                                    minDate={range.from.minStartDate}
                                    maxDate={range.from.minEndDate}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                            <div className="col-6">
                                <DatePicker
                                    containerClassName="w-100"
                                    inputClass="form-control border-light-subtle"
                                    placeholder="To"
                                    value={draft[range.to.key]}
                                    onChange={(date) => updateDraft(range.to.key, date)}
                                    minDate={range.to.minStartDate}
                                    maxDate={range.to.minEndDate}
                                    format="DD-MM-YYYY"
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-4 pt-3 border-top d-flex justify-content-between align-items-center gap-2">
                <button className="btn btn-sm resetBtn border-0 fw-bold" onClick={() => { resetFilter?.(); onClose(); }}>
                    Clear all
                </button>
                <button className="btn btn-primary btn-sm px-4" onClick={applyFilters} disabled={!hasChanges}>
                    Apply filters
                </button>
            </div>
        </div>
    );
};

export default Filter;
